import { render, staticRenderFns } from "./BaseTextareaContacts.vue?vue&type=template&id=791dc6b2&scoped=true&"
import script from "./BaseTextareaContacts.vue?vue&type=script&lang=js&"
export * from "./BaseTextareaContacts.vue?vue&type=script&lang=js&"
import style0 from "./BaseTextareaContacts.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./BaseTextareaContacts.vue?vue&type=style&index=1&id=791dc6b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "791dc6b2",
  null
  
)

export default component.exports